// src/components/chat/TypingIndicator.jsx
import React, { useState, useEffect } from 'react';

export default function TypingIndicator({ initial = false }) {
  // Predefined list of friendly messages
  const friendlyMessages = [
    "Warming up your chat...",
    "Fetching the latest news..."
  ];

  // State to track the current message index
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  // When in initial mode, iterate through the messages every 3 seconds
  useEffect(() => {
    if (initial) {
      const intervalId = setInterval(() => {
        setCurrentMessageIndex(prevIndex => (prevIndex + 1) % friendlyMessages.length);
      }, 3000);
      return () => clearInterval(intervalId);
    }
  }, [initial, friendlyMessages.length]);

  if (initial) {
    return (
      <div className="flex flex-col items-center justify-center p-4">
        <div className="relative">
          {/* Gradient spinner with rotation */}
          <div
            className="w-12 h-12 rounded-full border-4 border-transparent bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 animate-spin"
            style={{ backgroundSize: '200% 200%' }}
          ></div>
          {/* Center dot */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-4 h-4 bg-white rounded-full shadow-lg"></div>
          </div>
        </div>
        <span className="mt-3 text-lg font-semibold text-gray-800">
          {friendlyMessages[currentMessageIndex]}
        </span>
      </div>
    );
  }

  // Fallback: Three bouncing dots for in-conversation state.
  return (
    <div className="flex items-center space-x-1">
      <div
        className="w-2 h-2 bg-gray-600 rounded-full animate-bounce"
        style={{ animationDelay: "0s" }}
      ></div>
      <div
        className="w-2 h-2 bg-gray-600 rounded-full animate-bounce"
        style={{ animationDelay: "0.2s" }}
      ></div>
      <div
        className="w-2 h-2 bg-gray-600 rounded-full animate-bounce"
        style={{ animationDelay: "0.4s" }}
      ></div>
    </div>
  );
}
